import { z } from "zod";

const schema = z.object({
  availabilityFullTime: z.boolean().optional(),
  availabilityFractional: z.boolean().optional(),
  availabilityAdvisory: z.boolean().optional(),
  availabilityBoard: z.boolean().optional(),
  availabilityTime: z.string().optional(),
  availabilityStartDate: z.date().optional(),
});

type Schema = z.infer<typeof schema>;

export {
  schema as candidateAvailabilityFormSchema,
  type Schema as CandidateAvailabilityFormSchema,
};
